// Auto generated file, do not manually modify!
// java.time.DayOfWeek

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}

export const DayOfWeek_values = [
  DayOfWeek.FRIDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.SATURDAY,
  DayOfWeek.SUNDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
] as const;
